/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locationprefilledfromlisting3Inputs */

const en_locationprefilledfromlisting3 = /** @type {(inputs: Locationprefilledfromlisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location has been pre-filled from the selected listing. You can modify it if needed.`)
};

const de_locationprefilledfromlisting3 = /** @type {(inputs: Locationprefilledfromlisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Standort wurde vom ausgewählten Ort übernommen. Du kannst ihn ändern.`)
};

/**
* | output |
* | --- |
* | "Location has been pre-filled from the selected listing. You can modify it if needed." |
*
* @param {Locationprefilledfromlisting3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const locationprefilledfromlisting3 = /** @type {((inputs?: Locationprefilledfromlisting3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locationprefilledfromlisting3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locationprefilledfromlisting3(inputs)
	return de_locationprefilledfromlisting3(inputs)
});
export { locationprefilledfromlisting3 as "locationPrefilledFromListing" }